import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Autocomplete, {
  AutocompleteInputChangeReason,
} from "@material-ui/lab/Autocomplete";
import { searchExternalArtists } from "../../../../../sdk/artists";
import { ArtistSearchResult } from "../../../../../../../../services/artist/types/artist-search-result";
import { TextField, IconButton } from "@material-ui/core";

interface AddArtistDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onAddArtist: (artist: ArtistSearchResult) => void;
}

export const AddArtistDialog: React.FC<AddArtistDialogProps> = (props) => {
  const [options, setOptions] = React.useState<ArtistSearchResult[]>([]);
  const [selectedArtist, setSelectedArtist] =
    React.useState<ArtistSearchResult | null>();

  const onInputChange = (
    _event: React.ChangeEvent<{}>,
    value: string,
    _reason: AutocompleteInputChangeReason
  ) => {
    if (value.length > 2) {
      searchExternalArtists(value).then((res) => {
        setOptions(res.spotify);
      });
    }
  };

  return (
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogContent>
        <DialogContentText>Add Main Artist to Release:</DialogContentText>
        <Autocomplete
          id="artist-select"
          options={options}
          onInputChange={onInputChange}
          getOptionLabel={(option) => option.name}
          style={{ width: 400 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select an artist"
              variant="outlined"
            />
          )}
          renderOption={(option) => (
            <React.Fragment>
              <IconButton color="primary">
                <img
                  src={option.avatar}
                  height={40}
                  width={40}
                  style={{ borderRadius: 40 }}
                  alt={option.name}
                />
              </IconButton>
              {option.name}
            </React.Fragment>
          )}
          onChange={(_event, value, _reason) => setSelectedArtist(value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            if (selectedArtist) {
              props.onAddArtist(selectedArtist);
            }
          }}
          color="default"
        >
          Add Artist
        </Button>
      </DialogActions>
    </Dialog>
  );
};
